"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const organisms_1 = require("../../organisms");
function SliderPanelMobile({ onHideSliderButtonClick, }) {
    const isScaleHintVisible = (0, hooks_1.useScaleHintVisible)();
    const bridge = (0, bridge_1.useBridge)();
    return ((0, jsx_runtime_1.jsxs)(atoms_1.AnimationWrapper, { "data-e2e": 'SliderPanelMobile_AnimationWrapper', children: [(0, jsx_runtime_1.jsx)(organisms_1.ModelSizeSlider, { isMobile: true, isScaleHintVisible: isScaleHintVisible, onValueChange: value => bridge === null || bridge === void 0 ? void 0 : bridge.liveModeSliderAction(value), "data-e2e": 'SliderPanelMobile_ModelSizeSlider' }), (0, jsx_runtime_1.jsx)(StyledButton, { iconName: ui_1.Icons.Arrow_Down, onClick: onHideSliderButtonClick, "data-e2e": 'SliderPanelMobile_StyledButton' })] }));
}
const StyledButton = (0, styled_components_1.default)(atoms_1.ArModeButton) `
  width: auto;

  background: none;
  border-radius: 0;
`;
exports.default = SliderPanelMobile;
